import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { Product } from '@/types/database';

export const useFeaturedProducts = (limit: number = 4) => {
  return useQuery({
    queryKey: ['featured-products', limit],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('products')
        .select(`
          *,
          category:categories(*),
          brand:brands(*),
          variations:product_variations(*)
        `)
        .eq('active', true)
        .eq('featured', true);

      if (error) throw error;
      
      if (!data || data.length === 0) {
        return [];
      }
      
      // Si hay más productos que el límite, seleccionar aleatoriamente
      if (data.length > limit) {
        const shuffled = [...data].sort(() => Math.random() - 0.5);
        return shuffled.slice(0, limit) as Product[];
      }
      
      return data as Product[];
    },
  });
};
